import { AppTheme } from 'core/theme/types/main'
import { appCreateStyles } from 'core/theme/utils/create-styles'

export function styles({ custom, spacing, palette }: AppTheme) {
  return appCreateStyles({
    root: {
      backdropFilter: 'blur(16px)',
    },
    paper: {
      backgroundColor: custom.colors.gray[500],
      padding: spacing(8),
      borderRadius: 20,
      boxShadow: '-1px 9px 10px rgba(0, 0, 0, 0.25)',
    },
    title: {
      color: custom.colors.gray[200],
      fontWeight: 700,
      fontSize: 20,
      marginBottom: spacing(3),
    },
    question: {
      color: custom.colors.gray[200],
      fontWeight: 700,
      fontSize: 14,
      marginBottom: spacing(10),
    },
    control: {
      marginRight: spacing(2),
      background: 'none',
      color: custom.colors.gray[200],

      '&:hover': {
        color: palette.primary.light,
        background: 'none',
      },

      '&:last-of-type': {
        marginRight: 0,
      },
    },
  })
}
